import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/train-change-list',
      name: 'admin-train-change-list',
      component: () => import(/* webpackChunkName: "page-admin-train-order--management-train-change-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "改签列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "火车票订单管理"
                                        },
                                        {
                                                  name: "改签列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
